/* eslint-disable padding-line-between-statements */
import { BreakpointTrackerContext } from '@jutro/layout';
import { IntlContext, TranslatorContext } from '@jutro/locale';
import { Link } from '@jutro/router';
import { ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import _ from 'lodash';
import React, { 
    useCallback, 
    useEffect,
    useContext } 
from 'react';
import { withRouter } from 'react-router-dom';
import messages from './SubmissionSuccessfulPage.messages.js';
import metadata from './SubmissionSuccessfulPage.metadata.json5';
import styles from './SubmissionSuccessfulPage.module.scss';


// 2025-01-17 - Debra Frum - US25427 - CE - Make a Payment on Offer Details
// Display Submission Successful confirmation page after user successfully submits and pays for their 
// offer and policy has been issued

function SubmissionSuccessfulPage(props) {
    const breakpoint = useContext(BreakpointTrackerContext);
    const intlContext = useContext(IntlContext);
    const translator = useContext(TranslatorContext);
    const viewModelService = useContext(ViewModelServiceContext);
    const { location, history } = props;
    const { policyData } = location.state;

    const currentPeriod = _.get(policyData, 'currentPeriod');
    const policyNumber = _.get(currentPeriod, 'policyNumber');
    const periodEndDate = _.get(currentPeriod, 'expiration');
    const periodStartDate = _.get(currentPeriod, 'effective');

    const customerPaymentDetails = _.get(policyData, 'bindData_TWIA.customerPaymentDetails_TWIA');
    const physicalDeliveryPreference = _.get(customerPaymentDetails, 'physicalPreference')
    const nextInvoiceAmount = _.get(customerPaymentDetails, 'nextInvoiceAmount');
    const nextInvoiceDate = _.get(customerPaymentDetails, 'nextInvoiceDate');

    const paymentMethodTypelist = viewModelService?.productMetadata?.get('pc').types.getTypelist('PaymentMethod_TWIA');
    const policyDocumentPath = `${process.env.PUBLIC_PATH}/account-policy-details/${policyNumber}`;
    const policyRedirectPath = `/account-policy-details/${policyNumber}`;
    // const authHeader = location.state.authHeader;
    // const [isLoading, setIsLoading] = useState(false);


    useEffect(() => {
        if (_.isNil(policyData)) {
            history.push('/home');
        }
    }, [history, policyData]);


    const policyPrintDocument = useCallback(async () => {
        window.print() // DE16769
    }, []);
        
   const getPolicyNumberLink = useCallback(() => (
        <Link to={policyRedirectPath}>
            {policyNumber}
        </Link>
    ), [policyNumber, policyRedirectPath]);

    const formatDate = (date) => {
        if (!_.isNil(date)) {
            return intlContext.formatDate(date, {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
            });
        }
        return '';
    };

    const formatPolicyPeriod = (startDate, endDate) => {
        const formattedStartDate = formatDate(startDate);
        const formattedEndDate =  formatDate(endDate);

        return `${formattedStartDate} - ${formattedEndDate}`;
    };
    
    const getPaymentMethod = useCallback(() => {
        const paymentMethod = _.get(policyData, 'bindData_TWIA.paymentDetails.paymentMethod_TWIA');

        if (!_.isNil(paymentMethod)) {
            const result = paymentMethodTypelist?.codes?.filter(item => item.code === paymentMethod);
            if (!_.isNil(result)) {
                return translator({
                    id: result[0].name,
                    defaultMessage: result[0].name
                })
            }
        }
        return '';
    }, [policyData, paymentMethodTypelist, translator]);

    const isNextInstallmentVisible = () => (
            !_.isNil(nextInvoiceAmount?.amount) 
        ||  !_.isNil(nextInvoiceDate));

    const overrideProps = {
        '@field': {
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
            readOnly: true
        },
        policyMailedMessage: {
            visible: physicalDeliveryPreference 
        },
        policyDescriptionDocumentList: {
            content: translator(messages.policyDescriptionCDocumentList)
        },
        policyNumber: {
            value: getPolicyNumberLink()
        },
        policyPeriod: {
            value: formatPolicyPeriod(periodStartDate, periodEndDate)
        },
        totalPremium: {
            value: {
                amount: _.get(currentPeriod, 'cost.amount'),
                currency: _.get(currentPeriod, 'cost.currency'),
            }
        },
        nextInstallmentAmount: {
            value: {
                amount: nextInvoiceAmount?.amount,
                currency: nextInvoiceAmount?.currency,
            },
            visible: isNextInstallmentVisible()
        },
        nextInstallmentDueDate: {
            value: nextInvoiceDate,
            visible: isNextInstallmentVisible()
        },
        policyDescriptionHere: {
            to: policyDocumentPath
        },
        paymentMethod: {
            value : getPaymentMethod()
        },
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            policyPrintDocument,
            getPolicyNumberLink,
            getPaymentMethod,
        },
    };

    return (
        <ViewModelForm
                uiProps={metadata.pageContent}
                model={policyData}
                overrideProps={overrideProps}
                classNameMap={resolvers.resolveClassNameMap}
                callbackMap={resolvers.resolveCallbackMap}
        />
    );
}

export default withRouter(SubmissionSuccessfulPage);
